// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pV","embed":"pW"};